import _isEmpty from 'lodash/isEmpty';
import _every from 'lodash/every';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _slice from 'lodash/slice';
import _difference from 'lodash/difference';
import { SHIFT_KEY_CODE } from './withCheckboxTable.constants';
export var getSelectedIdSet = function getSelectedIdSet(selectedIds) {
  return new Set(selectedIds);
};
export var getIndeterminateSet = function getIndeterminateSet(indeterminateIds) {
  return new Set(indeterminateIds);
};
export var getTableDataIds = function getTableDataIds(tableData, getId) {
  return _map(tableData, getId);
};
export var isAllSelected = function isAllSelected(tableDataIds, selectedIdSet) {
  if (selectedIdSet.size === 0 || _isEmpty(tableDataIds)) return false;
  return _every(tableDataIds, function (id) {
    return selectedIdSet.has(id);
  });
};
export var isIndeterminate = function isIndeterminate(tableDataIds, selectedIdSet, indeterminateIdSet) {
  if (!_isEmpty(indeterminateIdSet)) return true;
  if (_isEmpty(tableDataIds) || selectedIdSet.size === 0) return false;
  var atleastOneSelected = false;
  var atleastOneNotSelected = false;
  for (var index = 0; index < tableDataIds.length; index += 1) {
    var id = tableDataIds[index];
    if (selectedIdSet.has(id)) {
      atleastOneSelected = true;
    } else {
      atleastOneNotSelected = true;
    }
    if (atleastOneSelected && atleastOneNotSelected) {
      return true;
    }
  }
  return false;
};
export var getValidSelectedIdsBetweenIndices = function getValidSelectedIdsBetweenIndices(data, fromIndex, toIndex, getId, disabled) {
  var idsInBetween = _map(_slice(data, fromIndex, toIndex), getId);
  return _difference(idsInBetween, disabled);
};
export var isShiftKey = function isShiftKey(evt) {
  return _get(evt, 'which') === SHIFT_KEY_CODE;
};